export class HorizontalScroller {
    list_item_data_attr: string;
    gap_in_pixel: number;
    direction = 0;
    position = 0;
    scroll_distance = 100;
    resizeObserver: ResizeObserver;

    constructor(list_item_data_attr: string, gap_class: string) {
        this.list_item_data_attr = list_item_data_attr;
        const quarter_rem_in_pixel = 4;
        this.gap_in_pixel = Number(gap_class.replace('gap-', '')) * quarter_rem_in_pixel;
        this.init();
    }

    init() {
        if (this.list_item_data_attr) {
            this.observeListItemWidth(this.list_item_data_attr);
        }
    }

    destroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    observeListItemWidth(list_item_data_attr: string) {
        const item = document.querySelector(`[${list_item_data_attr}]`);
        this.resizeObserver = new ResizeObserver((entries) => {
            this.scroll_distance = entries[0].target.getBoundingClientRect().width + this.gap_in_pixel;
        });
        if (item) {
            this.resizeObserver.observe(item);
        }
    }

    scrollLeft() {
        this.direction = -1;
    }

    scrollRight() {
        this.direction = 1;
    }

    onScroll($el: HTMLElement) {
        $el.scrollTo({
            left: $el.scrollLeft + this.scroll_distance * this.direction,
            top: 0,
            behavior: 'smooth',
        });
        this.direction = 0;
    }
}
